/* bnd-pdp.js — weight picker + add to cart for the native bundle PDP. Vanilla, no dependencies. */
(function () {
  'use strict';
  function init(root) {
    var dataEl = root.querySelector('[data-bnd-data]'), V = [];
    try { V = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var by = {}; V.forEach(function (v) { by[v.id] = v; });
    var idIn = root.querySelector('[data-bnd-id]'), price = root.querySelector('[data-bnd-price]'), was = root.querySelector('[data-bnd-was]'),
        save = root.querySelector('[data-bnd-save]'), per = root.querySelector('[data-bnd-per]'), cta = root.querySelector('[data-bnd-cta]'), lo = root.querySelector('[data-bnd-lo-p]'),
        ctaT = root.querySelector('[data-bnd-cta-t]'), err = root.querySelector('[data-bnd-err]'), form = root.querySelector('[data-bnd-form]');
    var sBar = root.querySelector('[data-bnd-sticky]'), sp = root.querySelector('[data-bnd-sticky-p]'), sb = root.querySelector('[data-bnd-sticky-btn]'), sbT = root.querySelector('[data-bnd-sticky-t]');
    var pending = false;
    function show(id) {
      var v = by[id]; if (!v) return;
      idIn.value = id; price.textContent = v.pf; if (lo && v.lo) lo.textContent = v.lo; per.textContent = v.pd + '/day';
      if (was) { was.textContent = v.wf; was.hidden = !v.wf; } if (save) save.hidden = !v.wf;
      cta.disabled = !v.av || pending; ctaT.textContent = v.av ? (root.getAttribute('data-po-cta') || 'Add to cart') + ' · ' + v.pf : 'Sold out';
      if (sp) sp.textContent = v.pf; if (sb) { sb.disabled = !v.av || pending; sbT.textContent = v.av ? (root.getAttribute('data-po-cta') || 'Add to cart') : 'Sold out'; }
      try { var u = new URL(location.href); u.searchParams.set('variant', id); history.replaceState(null, '', u); } catch (e) {}
    }
    root.querySelectorAll('[data-bnd-size]').forEach(function (r) { r.addEventListener('change', function () { if (r.checked) show(r.value); }); });
    root.querySelectorAll('[data-bnd-size]').forEach(function (r) {
      r.addEventListener('focus', function () {
        var grid = r.closest('.bnd-sizes__grid'), tile = r.closest('.bnd-size');
        if (grid.scrollWidth > grid.clientWidth) grid.scrollLeft = tile.offsetLeft - grid.firstElementChild.offsetLeft;
      });
    });
    var gallery = root.querySelector('.bnd-gal__track'), prev = root.querySelector('[data-bnd-gallery-prev]'), next = root.querySelector('[data-bnd-gallery-next]');
    if (gallery && prev && next) {
      var slides = gallery.children.length, count = root.querySelector('[data-bnd-gallery-count]');
      function galleryIndex() { return Math.round(gallery.scrollLeft / gallery.clientWidth); }
      function galleryState() {
        var index = galleryIndex(); prev.disabled = index === 0; next.disabled = index >= slides - 1;
        count.textContent = (index + 1) + ' / ' + slides;
      }
      function galleryMove(step) { gallery.scrollTo({ left: (galleryIndex() + step) * gallery.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' }); }
      prev.addEventListener('click', function () { galleryMove(-1); });
      next.addEventListener('click', function () { galleryMove(1); });
      gallery.addEventListener('scroll', galleryState, { passive: true });
      galleryState();
    }
    var chk = root.querySelector('[data-bnd-size]:checked'); if (chk) {
      show(chk.value);
      var g0 = chk.closest('.bnd-sizes__grid'), t0 = chk.closest('.bnd-size');
      if (g0 && t0 && g0.scrollWidth > g0.clientWidth) g0.scrollLeft = t0.offsetLeft - g0.firstElementChild.offsetLeft;
    }
    if (sBar && sb) {
      var sFoot = document.querySelector('footer, .shopify-section-group-footer-group'), sOn = null, sTick = 0;
      var sPaint = function () {
        sTick = 0; var r = cta.getBoundingClientRect(), h = document.querySelector('header.shopify-section-group-header-group') || document.querySelector('header');
        var hb = h ? Math.max(0, Math.round(h.getBoundingClientRect().bottom)) : 0;
        var out = r.top >= innerHeight || r.bottom <= hb, footIn = !!sFoot && sFoot.getBoundingClientRect().top < innerHeight;
        var on = matchMedia('(max-width: 749px)').matches && out && !footIn;
        document.documentElement.classList.add('bnd-sticky-init');
        if (on === sOn) return; sOn = on; sBar.classList.toggle('is-on', on); sBar.setAttribute('aria-hidden', on ? 'false' : 'true'); sb.tabIndex = on ? 0 : -1;
      };
      var sSched = function () { if (!sTick) sTick = requestAnimationFrame(sPaint); };
      addEventListener('scroll', sSched, { passive: true }); addEventListener('resize', sSched); sPaint();
      sb.addEventListener('click', function () { if (!cta.disabled) form.requestSubmit ? form.requestSubmit() : cta.click(); });
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault(); if (cta.disabled || pending) return;
      var sentId = Number(idIn.value); pending = true;
      err.hidden = true; cta.disabled = true; if (sb) sb.disabled = true;
      var drawer = document.querySelector('cart-drawer'), payload = { items: [{ id: sentId, quantity: 1 }] };
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        payload.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }); payload.sections_url = location.pathname;
        if (drawer.setActiveElement) drawer.setActiveElement(cta);
      }
      fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(payload) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (x) {
          if (!x.ok) throw new Error(x.j && (x.j.description || x.j.message) || 'Could not add to cart');
          try { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bnd', productVariantId: sentId, cartData: x.j }); } catch (z) {}
          if (drawer && x.j.sections && typeof drawer.renderContents === 'function') drawer.renderContents(x.j, true);
          else location.href = '/cart';
        })
        .catch(function (ex) { err.textContent = ex.message || 'Could not add to cart. Please try again.'; err.hidden = false; })
        .then(function () { pending = false; cta.disabled = !by[idIn.value].av; if (sb) sb.disabled = cta.disabled; });
    });
  }
  function boot() { document.querySelectorAll('[data-bnd]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
